import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
`;

export const Top = styled.div`
  width: 1200px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  padding: 5px;
  font-family: monospace;

  div {
    &::before {
      content: ' * ';
      margin-right: 15px;
      color: red;
    }

    span {
      padding: 0 10px;
      color: #333;
      border-radius: 3px;
    }

    &.gold {
      color: gold;
    }

    &.NOG {
      span {
        background-color: yellowgreen;
      }
    }

    &.SODA {
      span {
        background-color: pink;
      }
    }

    &.TEXTACO {
      span {
        background-color: #ffbf00;
      }
    }

    &.IMAGE-TO-3D {
      span {
        background-color: cyan;
      }
    }
  }
`;

export const Image = styled.div`
  width: 1200px;
  height: 600px;
  box-shadow: inset 0 0 5px 15px rgba(0, 0, 0, 0.15);
  background-color: #111;
  position: relative;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 1200px;
  padding: 20px;
`;

export const Keys = styled.div`
  width: 160px;
  color: gray;
  text-align: center;
  padding: 5px;
`;

export const Prompt = styled.div`
  position: absolute;
  bottom: 50px;
  left: 50%;
  width: 600px;
  transform: translateX(-50%);
  text-align: center;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
